<template>
  <div>
    <page-toolbar>
      <report-date-picker v-model="selectedDate" />
      <kendo-dropdownlist
        :data-source="sectorDataSource"
        :data-text-field="'sectorCode'"
        :data-value-field="'sectorId'"
        v-model="sectorId"
        style="width: 100px;"
      >
      </kendo-dropdownlist>
      <kendo-button icon="add" title="Add Dashboard" v-if="!isReadOnly" @click="addDashboard">
      </kendo-button>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
      <kendo-button
        v-if="!isReadOnly"
        icon="copy"
        title="Copy Dashboards"
        @click="showCopyDashboardForm = true"
      ></kendo-button>
    </page-toolbar>
    <kendo-grid
      :height="this.clientId == 0 ? 'calc(100vh - 232px)' : 'calc(100vh - 182px)'"
      @edit="gridEdit"
      :dataSource="topDataSource"
      :editable="!isReadOnly && 'inline'"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :columns="topColumns"
      :detailInit="detailInit"
      :detailExpand="topDetailExpand"
      :detailCollapse="topDetailCollapse"
    >
    </kendo-grid>
    <dashboard-form
      v-if="editDashboardId != null"
      @close="onDashboardFormClose"
      :dashboard-id="editDashboardId"
      @save="onDashboardFormSave"
    >
    </dashboard-form>
    <copy-dashboard-form
      @close="onCopyDashboardClose"
      @copy="onDashboardCopied"
      v-if="showCopyDashboardForm"
    >
    </copy-dashboard-form>
    <v-layout row justify-center>
      <v-dialog v-model="showPdfProgress" persistent max-width="400" height="500">
        <v-card>
          <v-card-title class="headline">Generating Report</v-card-title>
          <v-card-text class="justify-center">
            {{ pdfMessage }}
            <v-layout justify-center>
              <v-progress-circular :size="80" :width="5" color="primary" :indeterminate="true">
                {{ pdfProgress }} %
              </v-progress-circular>
            </v-layout>
          </v-card-text>

          <div>
            <v-progress-linear v-model="pdfProgress"></v-progress-linear>
          </div>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import notification from '../../helpers/notification'

const $ = kendo.jQuery
import {checkboxColumn, jsonDropDownEditor, numericEditor} from '@/helpers/kendo-editors'
import axios from 'axios'
import dashboardForm from '@/components/Report/DashboardPage/dashboardForm'
import copyDashboardForm from '@/components/Report/DashboardPage/copyDashboardForm'
import {getDataItem} from '@/helpers/kendo-helpers'
import dashboardService from '@/services/dashboard'
import PageToolbar from '@/components/PageToolbar'
import ReportDatePicker from '@/components/ReportDatePicker'
import security from '@/mixins/security'

export default {
  name: 'DashboardPage',
  mixins: [security],
  data() {
    return {
      showPdfProgress: false,
      pdfProgress: 0,
      pdfMessage: 'Loading...',
      showCopyDashboardForm: false,
      dashboadId: 1,
      sectorId: -1,
      editDashboardId: null,
      expandedDashboardComponentId: -1,
      selectedDate: new Date(),
      topDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/dashboardPage',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/dashboardPage',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/dashboardPage',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dashboardId',
            fields: {
              dashboardId: {type: 'number'},
              label: {type: 'string'},
              description: {type: 'string'},
              note: {type: 'string'},
              disclaimer: {type: 'string'},
              language: {type: 'string'},
              languageId: {type: 'number', defaultValue: 1},
              isAutomatic: {type: 'boolean', defaultValue: true},
              canBeDeleted: {type: 'boolean', defaultValue: true, editable: false},
            },
          },
        },
      }),
      sectorDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/report/dashboardPage/getSectors',
            contentType: 'application/json',
            data: () => ({clientId: this.clientId}),
            type: 'GET',
          },
        },
      }),
    }
  },
  beforeDestroy() {
    const $ = kendo.jQuery
    const iframe = $('#pdfExportIframe')
    if (iframe.length) {
      iframe.remove()
    }
  },
  methods: {
    exportPdf(e) {
      e.preventDefault()

      const dataItem = getDataItem(e.target)
      this.setGridLoading(true)

      dashboardService
        .loadIframe(dataItem.id, this.selectedDate, this.sectorId, ({name, message, progress}) => {
          if (message) {
            this.pdfMessage = message
          }

          if (name == 'rendering') {
            this.pdfProgress = progress
          }
        })
        .catch(e => {
          notification('Error producing dashboard: ' + e.message, 'error')
          this.setGridLoading(false)
        })
        .then(() => this.setGridLoading(false))

      return false
    },
    setGridLoading(status) {
      const grid = this.$refs.grid.kendoWidget()
      kendo.ui.progress(grid.element, status)
      this.showPdfProgress = status
      this.pdfMessage = ''
      this.pdfProgress = 0
    },
    onCopyDashboardClose() {
      this.showCopyDashboardForm = false
    },
    onDashboardCopied() {
      this.showCopyDashboardForm = false
      this.$refs.grid.kendoWidget().dataSource.read()
    },
    onDashboardFormClose() {
      this.editDashboardId = null
    },
    onDashboardFormSave(e) {
      this.editDashboardId = e.dashboadId
      this.$refs.grid.kendoWidget().dataSource.read()
    },
    addDashboard() {
      this.editDashboardId = 0
    },
    gridEdit(e) {
      this.editDashboardId = e.model.dashboardId
      e.sender.cancelChanges()
    },
    exportToExcel() {
      window.location.href = `/api/report/dashboardPage/exportToExcel?clientId=${this.clientId}&t=${
        this.tokenString
      }`
    },
    topDetailExpand(ev) {
      let expandedRow = $(ev.sender.wrapper).data('expandedRow')
      // Only one open at a time
      if (expandedRow && expandedRow[0] != ev.masterRow[0]) {
        let grid = $(ev.sender.wrapper).data('kendoGrid')
        grid.collapseRow(expandedRow)
      }
      $(ev.sender.wrapper).data('expandedRow', ev.masterRow)
    },
    topDetailCollapse(ev) {
      let expandedRow = $(ev.sender.wrapper).data('expandedRow')
      expandedRow
        .next()
        .find('.k-grid')
        .getKendoGrid()
        .destroy()
      expandedRow.next().remove()
    },
    groupFactorDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'groupFactorId',
        'groupFactor',
        '/api/report/dashboardPage/getGroupFactors',
        {},
        true,
      ).call(this, container, options)
    },
    reportComponentDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'reportComponentId',
        'reportComponent',
        '/api/report/dashboardPage/getReportComponents',
        {},
        true,
      ).call(this, container, options)
    },
    dataInstrumentDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'dataInstrumentId',
        'instrumentLabel',
        '/api/report/dashboardPage/getDataInstruments',
        {},
        true,
      ).call(this, container, options)
    },
    ccyPairDropDownEditor(container, options) {
      return jsonDropDownEditor('ccyPairId', 'ccyPairCode', '', {
        dataSource: {
          transport: {
            read: {
              url: '/api/list/FxRate/getForecastRateCcy',
              data: () => ({
                clientId: 0,
                marketId: -1,
              }),
              contentType: 'application/json',
              type: 'GET',
            },
          },
        },
        filter: 'contains',
      }).call(this, container, options)
    },
    detailInit(e) {
      const vm = this
      const editable = !vm.isReadOnly
      const $container = $("<div id='detailGrid'/>")
      const dashboardId = e.data.dashboardId
      const columns = [
        {command: 'edit', title: '&nbsp;', width: 50, hidden: !editable},
        {
          field: 'titleLabel',
          title: 'Title',
          width: 200,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="titleLabel" required="required" type="text" class="k-input k-textbox" data-bind="value:titleLabel" />',
        },
        {
          field: 'subTitleLabel',
          title: 'Sub Title',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="subTitleLabel" type="text" class="k-input k-textbox" data-bind="value:subTitleLabel" />',
        },
        {
          field: 'note',
          title: 'Note',
          width: 300,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="note" type="text" class="k-input k-textbox" data-bind="value:note" />',
        },
        {
          field: 'reportComponent',
          title: 'Report Component',
          width: 150,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: vm.reportComponentDropDownEditor,
        },
        {
          field: 'groupFactor',
          title: 'Group Factor',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: vm.groupFactorDropDownEditor,
          hidden: true,
        },
        {
          field: 'nbMonths',
          title: 'Nb. Of Months',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor: numericEditor(
            {
              decimals: 0,
              format: '{0:n0}',
              spinners: false,
            },
            false,
          ),
        },
        checkboxColumn('quarterly', {title: 'Quarterly', width: 120}, !editable),
        checkboxColumn('fitInOnePage', {title: 'Fit In One Page', width: 120}, !editable),
        ...(editable
          ? [
              {
                command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
                width: 50,
              },
            ]
          : []),
      ]

      let detailGrid = $container
        .appendTo(e.detailCell)
        .kendoGrid({
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 30,
            transport: {
              read: {
                type: 'GET',
                url: '/api/report/dashboardPage/readDetailGrid',
                data: () => ({dashboardId: dashboardId}),
                dataType: 'json',
              },
              create: {
                type: 'POST',
                url: '/api/report/dashboardPage/createDetail',
                dataType: 'json',
              },
              update: {
                type: 'PUT',
                url: '/api/report/dashboardPage/updateDetail',
                dataType: 'json',
              },
              destroy: {
                type: 'DELETE',
                url: '/api/report/dashboardPage/destroyDetail',
                dataType: 'json',
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'dashboardComponentId',
                fields: {
                  dashboardComponentId: {type: 'number', editable: false, defaultValue: 0},
                  dashboardId: {type: 'number', defaultValue: dashboardId},
                  reportComponent: {type: 'string'},
                  reportComponentId: {type: 'number', defaultValue: 0},
                  titleLabel: {type: 'string', validation: {required: true}},
                  subTitleLabel: {type: 'string'},
                  note: {type: 'string'},
                  nbMonths: {type: 'number'},
                  sequence: {type: 'number'},
                  chartListId: {type: 'number'},
                  quarterly: {type: 'boolean'},
                  fitInOnePage: {type: 'boolean'},
                  groupFactor: {type: 'string'},
                  groupFactorId: {type: 'number', defaultValue: 0},
                  canBeDeleted: {type: 'boolean', defaultValue: true, editable: false},
                },
              },
            },
          },
          toolbar: editable ? ['create'] : [],
          editable: editable && {mode: 'inline', createAt: 'bottom'},
          scrollable: true,
          sortable: false,
          pageable: false,
          columns: columns,
          detailInit: vm.subDetailInit,
          detailExpand: function(ev) {
            let expandedRow = $(ev.sender.wrapper).data('expandedRow')
            // Only one open at a time
            if (expandedRow && expandedRow[0] != ev.masterRow[0]) {
              let grid = $(ev.sender.wrapper).data('kendoGrid')
              grid.collapseRow(expandedRow)
            }
            $(ev.sender.wrapper).data('expandedRow', ev.masterRow)
          },
          detailCollapse: function(ev) {
            let expandedRow = $(ev.sender.wrapper).data('expandedRow')

            expandedRow
              .next()
              .find('.k-grid')
              .getKendoGrid()
              .destroy()
            expandedRow.next().remove()
          },
          dataBound: function() {
            if (vm.expandedDashboardComponentId != -1) {
              let detailDataItem = detailGrid.dataSource.get(vm.expandedDashboardComponentId)
              if (detailDataItem == null) {
                return
              }

              let row = detailGrid.tbody.find("tr[data-uid='" + detailDataItem.uid + "']")
              this.expandRow(row)
            }
          },
        })
        .data('kendoGrid')

      if (editable) {
        detailGrid.table.kendoSortable({
          //>first descendant of the class tbody in this case
          filter: '>tbody >tr:not(tr[data-role=editable]):not(.k-detail-row)',
          hint: function(element) {
            //customize the hint
            let table = $('<table style="width: 1500px;" class="k-grid k-widget"></table>')

            table.append(element.clone()) //append the dragged element
            table.css('opacity', 0.7)

            return table //return the hint element
          },
          cursor: 'move',
          placeholder: function() {
            return $('<tr colspan="4" class="placeholder"></tr>')
          },
          change: async e => {
            let skip = detailGrid.dataSource.skip(),
              newIndex = e.newIndex + skip,
              selectedDataItem = detailGrid.dataSource.getByUid(e.item.data('uid'))

            detailGrid.dataSource.remove(selectedDataItem)
            detailGrid.dataSource.insert(newIndex, selectedDataItem)

            await axios.post('/api/report/dashboardPage/updateSequence', {
              dashboardId: dashboardId,
              selectedDashboardComponentId: selectedDataItem.dashboardComponentId,
              newIndex: e.newIndex,
            })
            await detailGrid.dataSource.read()
          },
        })
      }
    },
    subDetailInit(e) {
      const vm = this
      const editable = !vm.isReadOnly
      const $subDetailContainer = $("<div id='subDetailGrid' style='width: 350px;'/>")
      const chartListId = e.data.chartListId
      const dashboardComponentId = e.data.dashboardComponentId

      const suffix = e.data.reportComponentId == 8 ? 'CcyPair' : ''
      const column =
        e.data.reportComponentId == 8
          ? {
              field: 'ccyPairCode',
              title: 'Ccy/Comm Pair',
              width: 90,
              headerAttributes: {style: 'text-align: center;'},
              attributes: {style: 'text-align: left;'},
              editor: vm.ccyPairDropDownEditor,
            }
          : {
              field: 'instrumentLabel',
              title: 'Instrument',
              width: 90,
              headerAttributes: {style: 'text-align: center;'},
              attributes: {style: 'text-align: left;'},
              editor: vm.dataInstrumentDropDownEditor,
            }

      const columns = [
        {
          command: 'edit',
          title: '&nbsp;',
          width: 50,
          hidden: !editable,
        },
        column,
        ...(editable
          ? [
              {
                command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
                width: 50,
              },
            ]
          : []),
      ]

      let subDetailGridDataSource = new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/report/dashboardPage/readSubDetailGrid' + suffix,
            data: () => ({chartListId: chartListId, dashboardComponentId: dashboardComponentId}),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/report/dashboardPage/createSubDetail' + suffix,
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/report/dashboardPage/updateSubDetail' + suffix,
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/report/dashboardPage/destroySubDetail' + suffix,
            dataType: 'json',
          },
        },
        schema: {
          data: 'data',
          total: 'total',
          errors: 'errors',
          model: {
            id: 'chartListItemId',
            fields: {
              chartListItemId: {type: 'number'},
              chartListId: {type: 'number', defaultValue: chartListId},
              dashboardComponentId: {type: 'number', defaultValue: dashboardComponentId},
              dataInstrumentId: {type: 'number', defaultValue: 0},
              instrumentLabel: {type: 'string'},
              ccyPairId: {type: 'number', defaultValue: 0},
              ccyPairCode: {type: 'string'},
              canBeDeleted: {type: 'boolean', defaultValue: true, editable: false},
            },
          },
        },
      })

      $subDetailContainer
        .appendTo(e.detailCell)
        .kendoGrid({
          dataSource: subDetailGridDataSource,
          toolbar: editable ? ['create'] : [],
          editable: editable && 'inline',
          scrollable: true,
          sortable: false,
          pageable: false,
          columns: columns,
        })
        .data('kendoGrid')
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    topColumns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          width: 50,
        },
        {
          field: 'label',
          title: 'Label',
          width: 182,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'description',
          title: 'Description',
          width: 232,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'note',
          title: 'Note',
          width: 232,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'language',
          title: 'Language',
          width: 100,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
        },
        checkboxColumn('isAutomatic', {title: 'Automatic', width: 120}),
        {
          command: {
            name: 'exportPdf',
            iconClass: 'k-icon k-i-file-pdf k-i-pdf',
            click: this.exportPdf,
          },
          title: ' ',
          width: 50,
        },
        {
          editable: !this.isReadOnly,
          command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
          width: 50,
        },
      ].filter(c => c.editable !== false)
    },
  },
  components: {
    PageToolbar,
    dashboardForm,
    copyDashboardForm,
    ReportDatePicker,
  },
}
</script>

<style scoped>
.k-grid tbody tr {
  cursor: move;
}

.placeholder {
  outline-style: dashed;
  outline-width: 1px;
  outline-color: red;
}
</style>
